import React from 'react';
import { Sliders } from 'lucide-react';
export function Rules() {
  return <div className="space-y-6" data-id="element-640">
      <div data-id="element-641">
        <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-642">
          Rules
        </h2>
        <p className="text-slate-500 mt-1" data-id="element-643">
          Configure automation rules for claim processing.
        </p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl p-16 flex flex-col items-center justify-center text-center shadow-sm" data-id="element-644">
        <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center mb-4" data-id="element-645">
          <Sliders className="w-6 h-6 text-slate-400" data-id="element-646" />
        </div>
        <p className="text-slate-500 text-sm" data-id="element-647">
          Rules configuration coming soon.
        </p>
      </div>
    </div>;
}